import { render, staticRenderFns } from "./SuaCanBo.vue?vue&type=template&id=f5e8ee16&"
import script from "./SuaCanBo.vue?vue&type=script&lang=js&"
export * from "./SuaCanBo.vue?vue&type=script&lang=js&"
import style0 from "./SuaCanBo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports